export default [
  {
    path: '/askPrice-:type-:id',
    component: () => import('@/views/askPrice/Index.vue'),
    name: 'askPrice',
    meta: {
      title: '门店询价',
      backgroundClass: 'bg-white',
    },
    hidden: true,
  },
  {
    path: '/askPrice-result',
    component: () => import('@/views/askPrice/Result.vue'),
    name: 'askPrice-result',
    meta: {
      title: '\u200E', //空
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
];
